<template>
  <b-modal :visible="isOpen"
           lazy
           centered
           ok-variant="ls"
           ok-title="Zamknij"
           ok-only
           :title="rewardOrder.reward_name"
           @hidden="clearModal"
           @shown="onShown"
           size="lg">
    <div v-if="stateOrder" v-html="digitalReward">

    </div>
  </b-modal>
</template>

<script>
  import {mapActions, mapState} from 'vuex';

  export default {
    name: "DigitalRewardModal",
    data() {
      return {
        isOpen: false,
        rewardOrder: {
          reward_name: '',
          details: '{}'
        }
      }
    },
    mounted() {
      this.setDelayDigitalRewardModal(false);
    },
    methods: {
      ...mapActions([
        'clearDigitalOrderModalId',
        'setDelayDigitalRewardModal'
      ]),
      clearModal() {
        this.isOpen = false;
        this.clearDigitalOrderModalId();
      },
      onShown() {
        this.fetchDigitalOrder();
      },
      fetchDigitalOrder() {
        return this.$http.get(`/reward/order/${this.stateOrder}`)
          .then((r) => {
            if (r.data.success) {
              this.rewardOrder = r.data.rewardOrder;
              if(r.data.rewardOrder.status === '5') {
                this.rewardOrder.details = '{"digitalReward": "Przygotowane nagrody trwa dłużej niż zwykle. Nagroda będzie możliwa do odbioru wkrótce."}';
              }
            } else {
              this.rewardOrder.reward_name = 'Wystąpił błąd';
              this.rewardOrder.details = '{"digitalReward": "Nie udało sie pobrać nagrody"}';
            }
          })
      }
    },
    computed: {
      ...mapState({
        isDigitalOrderIdSet: state => state.rewards.digitalOrderModalId !== null && !state.rewards.delayDigitalOrderModal,
        stateOrder: state => state.rewards.digitalOrderModalId,
      }),
      digitalReward() {
        return JSON.parse(this.rewardOrder.details).digitalReward
      },
    },
    watch: {
      isDigitalOrderIdSet(newVal) {
        if (newVal) {
          this.fetchDigitalOrder().then(() => {this.isOpen = true;});
        } else {
          this.isOpen = false;
        }
      }
    },
  }
</script>

<style>
  .modal-body {
    word-wrap: break-word;
  }
</style>
